//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { Enums, Activity } from '../../models/common'

import { default as apiModule, Api, LocalDictionaryFactory } from '../api/api.module'
import { default as commonModule } from '../common/common.module'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { ConfigHelper, UserSession } from '../../helpers'
import { OpOperator } from '../../models/core'

import { default as SERVICES_MODULE_NAME } from './../../services/services.module'
import { PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'
import { USER_SESSION_SERVICE_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, UserSessionService } from '../../services/user-session'
import { ALARM_GROUP_SERVICE_NAME, AlarmGroupService } from '../../services/alarm-group'
import { GRID_SERVICE_NAME, GridService } from '../../services/grid'

import { AlarmGroupsDetailsDirective } from './details/alarm-groups-details.directive'
import { AlarmGroupCreateEditDirective } from './create-edit/alarm-group-create-edit-popup.directive'
import { AlarmGroupsController } from "./alarm-groups.controller"

//#region Aseet Imports

import * as TEMPLATE from './alarm-groups.tpl.html'

//#endregion


// Consts

const CONTROLLER_NAME: string = 'AlarmGroupsController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'alarmGroupCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'alarmGroupsDetails'
const MODULE_NAME: string = 'simax.alarm-groups'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'ALARM_GROUP_NAME'
const STATE_NAME: string = 'alarmGroups'
const STATE_URL: string = '/alarmgroups'

// Consts End


// Setup

var module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'localDictionary',
    GRID_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    ALARM_GROUP_SERVICE_NAME,
    (
        $scope,
        $state: StateService,
        $timeout,
        api: Api,
        localDictionary: LocalDictionaryFactory,
        gridService: GridService,
        userSession: UserSessionService,
        systemService: SystemService,
        alarmGroupService: AlarmGroupService,
    ) => new AlarmGroupsController(
        $scope,
        $state,
        $timeout,
        api,
        localDictionary,
        gridService,
        userSession,
        systemService,
        alarmGroupService,
        Enums.ReferenceType.IdAlarmGroup,
        Enums.SimaxModuleName.Alarm_Group
    )])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new AlarmGroupsDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new AlarmGroupCreateEditDirective()])

module.config(['$stateProvider', USER_SESSION_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Alarm_Group_IdAlarmGroup',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.ALARM_GROUP_LIST)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.ALARM_GROUPS),
                    'alarmGroups',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    controllerAs: '$ctrl',
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

export default MODULE_NAME

// Setup End